"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.unregisterTCUser = exports.registerTCCustomerUser = exports.registerTCUser = void 0;

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _FlexMenuHelper = require("./FlexMenuHelper");

var _strings = require("../../config/strings");

var _Safeture = _interopRequireWildcard(require("../Safeture/Safeture"));

var registerTCUser = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(data) {
    var dataToStore, languages, primaryLangCode, primaryLanguage;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.log('registering', data);
            dataToStore = {};
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE] = data.countryOfResidence;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_AGENCY] = data.agencyKey;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_TARIFF] = data.tariffs;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_CORPORATE_CARD_ICON] = data.corporateIcon;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_SHOW_CORPORATE_CARD] = data.hasCorporateCard;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_POLICY_NUMBER] = data.policyNumber;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_POLICY_TYPE] = data.segmentType;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_POLICY_IS_TEST] = data.isTest;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_USER_ROLE] = _Safeture.REGISTER_STATUS.REGISTERED;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_AIRDOCTORS_ACTIVE] = data.canHaveAirDr;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_CONTRACT_START_DATE] = data.contractStartDate;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_IS_CUSTOMER_VERSION] = false;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_CUSTOMER_REGISTRATION_TIME] = null;
            _context.next = 17;
            return _DataStore["default"].setData(dataToStore);

          case 17:
            _context.next = 19;
            return (0, _FlexMenuHelper.getAvailableLanguages)(data.countryOfResidence);

          case 19:
            languages = _context.sent;
            _context.next = 22;
            return (0, _FlexMenuHelper.getPrimaryLangugage)(data.countryOfResidence);

          case 22:
            primaryLangCode = _context.sent;

            if (!(languages && languages.length > 0)) {
              _context.next = 30;
              break;
            }

            primaryLanguage = languages.find(function (language) {
              return language.langCode === primaryLangCode;
            }) || languages[0];
            _context.next = 27;
            return (0, _strings.setCurrentLanguage)(primaryLanguage.languageCode);

          case 27:
            _context.next = 29;
            return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_LANGUAGE, primaryLanguage);

          case 29:
            _Safeture["default"].setLanguage(primaryLanguage.languageCode);

          case 30:
            // Server has to answer with the production keys
            console.log('now we would register and subscribe to safeture again with the new keys, not there yet');
            _context.next = 33;
            return _Safeture["default"].activateCustomer();

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function registerTCUser(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.registerTCUser = registerTCUser;

var registerTCCustomerUser = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(customer, homeRegion) {
    var policyNumber, dataToStore, alreadyActivated;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            console.log('registering', customer);
            policyNumber = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_POLICY_NUMBER);
            dataToStore = {};
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_USER_ROLE] = _Safeture.REGISTER_STATUS.CUSTOMER;

            if (policyNumber) {
              _context2.next = 16;
              break;
            }

            dataToStore[_DataStore.DATA_STORE_PATHS.TC_IS_CUSTOMER_VERSION] = true;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_CUSTOMER_REGISTRATION_TIME] = (0, _now["default"])();
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_CUSTOMER_NAME] = customer || 'none';

            if (homeRegion) {
              console.log('setting homeRegion for tc customer', homeRegion);
              dataToStore[_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE] = homeRegion;
            }

            _context2.next = 11;
            return _DataStore["default"].setData(dataToStore);

          case 11:
            console.log('now we would register and subscribe to safeture again with the new keys, not there yet - no policy number');
            _context2.next = 14;
            return _Safeture["default"].activateCustomer();

          case 14:
            _context2.next = 28;
            break;

          case 16:
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_IS_CUSTOMER_VERSION] = false;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_CUSTOMER_REGISTRATION_TIME] = null;
            dataToStore[_DataStore.DATA_STORE_PATHS.TC_CUSTOMER_NAME] = customer || 'none';
            _context2.next = 21;
            return _DataStore["default"].setData(dataToStore);

          case 21:
            _context2.next = 23;
            return _Safeture["default"].checkIfRegistered();

          case 23:
            alreadyActivated = _context2.sent;

            if (alreadyActivated) {
              _context2.next = 28;
              break;
            }

            console.log('now we would register and subscribe to safeture again with the new keys, not there yet - we got a policy number');
            _context2.next = 28;
            return _Safeture["default"].activateCustomer();

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function registerTCCustomerUser(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.registerTCCustomerUser = registerTCCustomerUser;

var unregisterTCUser = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(policyOver) {
    var data;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            console.log('unregistering');
            data = {};
            data[_DataStore.DATA_STORE_PATHS.TC_AGENCY] = null;
            data[_DataStore.DATA_STORE_PATHS.TC_TARIFF] = null;
            data[_DataStore.DATA_STORE_PATHS.TC_CORPORATE_CARD_ICON] = null;
            data[_DataStore.DATA_STORE_PATHS.TC_SHOW_CORPORATE_CARD] = null;
            data[_DataStore.DATA_STORE_PATHS.TC_POLICY_NUMBER] = null;
            data[_DataStore.DATA_STORE_PATHS.TC_POLICY_TYPE] = null;
            data[_DataStore.DATA_STORE_PATHS.TC_POLICY_IS_TEST] = null;
            data[_DataStore.DATA_STORE_PATHS.TC_USER_ROLE] = _Safeture.REGISTER_STATUS.UNREGISTERED;
            data[_DataStore.DATA_STORE_PATHS.TC_AIRDOCTORS_ACTIVE] = false;
            data[_DataStore.DATA_STORE_PATHS.TC_CONTRACT_START_DATE] = null;
            data[_DataStore.DATA_STORE_PATHS.TC_PHONE_NUMBER] = null;
            _context3.next = 15;
            return _DataStore["default"].setData(data);

          case 15:
            if (!policyOver) {
              _context3.next = 19;
              break;
            }

            console.log('policy is over, safeture will be canceled from our side');
            _context3.next = 19;
            return _Safeture["default"].unregister();

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function unregisterTCUser(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

exports.unregisterTCUser = unregisterTCUser;